let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.addItemsToCart = function (line_items, submitButton = false) {
  this.cart = document.querySelector('cart-drawer');
  this.data = {};

  if (submitButton) {
    if (submitButton.getAttribute('aria-disabled') === 'true') return;

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
  }

  if (this.cart) {
    this.data.sections = [];
    this.data.section_url = window.location.pathname;
    this.cart.setActiveElement(document.activeElement);

    this.data.sections.push(
      ...this.cart.getSectionsToRender().map((section) => section.id)
    );
  } else {
    this.data.sections = 'cart-icon-bubble';
    this.data.section_url = window.location.pathname;
  }

  this.data.items = line_items;

  return fetch(`${routes.cart_add_url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/json`,
    },
    body: JSON.stringify(this.data),
  })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      if (this.cart) {
        this.cart.renderContents(response);
      } else {
        const cartBubble = document.querySelector('#cart-icon-bubble');

        if(!cartBubble) return;

        if (window.cartStrings.pulsate) {          
          cartBubble.classList.add('pulsate');

          setTimeout(() => {
            cartBubble.classList.remove('pulsate');
          }, 3000);
        }

        if (response.sections['cart-icon-bubble']) {
          const html = new DOMParser().parseFromString(
            response.sections['cart-icon-bubble'],
            'text/html'
          );

          cartBubble.querySelector('.cart-count-bubble__count').innerHTML =
            html.querySelector('.cart-count-bubble__count').innerHTML;            
        }
      }

      if (submitButton) {
        submitButton.setAttribute('aria-disabled', false);
        submitButton.classList.remove('loading');
      }
    });
};

Shopify.removeItemFromCart = function (line) {
  return fetch(`${routes.cart_change_url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/json`,
    },
    body: JSON.stringify({
      'line': line,
      'quantity': 0
    }),
  })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      
    });
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      //this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      //this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      //this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      //this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      filterMedia();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      filterMedia();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true,
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;


        const shadeDestination1 = document.getElementById(`ProductSelect1-${this.dataset.section}`);
        const shadeSource1 = html.getElementById(`ProductSelect1-${this.dataset.section}`);
        if (shadeSource1 && shadeDestination1) shadeDestination1.innerHTML = shadeSource1.innerHTML;

        const shadeDestination2 = document.getElementById(`ProductSelect2-${this.dataset.section}`);
        const shadeSource2 = html.getElementById(`ProductSelect2-${this.dataset.section}`);
        if (shadeSource2 && shadeDestination2) shadeDestination2.innerHTML = shadeSource2.innerHTML;

        const formButtonsDestination = document.getElementById(`ProductFormButtons-${this.dataset.section}`);
        const formButtonsSource = html.getElementById(`ProductFormButtons-${this.dataset.section}`);
        if (formButtonsSource && formButtonsDestination) formButtonsDestination.innerHTML = formButtonsSource.innerHTML;

        const stickyDestination = document.querySelector(`#ProductStickyForm-${this.dataset.section}`)
        const stickySource = html.querySelector(`#ProductStickyForm-${this.dataset.section}`);
        if (stickySource && stickyDestination) stickyDestination.innerHTML = stickySource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    console.log("varint chanhge");
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ShadeFilters extends HTMLElement {
  constructor() {
    super();

    this.variantRadios = this.closest("variant-radios");
    this.buttons = this.querySelectorAll(".shade-filter_button");

    this.shadeButtons = this.querySelectorAll(".shade-filter_button[data-shade]");
    this.undertoneButtons = this.querySelectorAll(".shade-filter_button[data-undertone]");

    this.variantLabels = this.variantRadios.querySelectorAll(".swatch-shade-label");

    this.buttons.forEach((button) => {
      button.addEventListener("click", this.handleClick.bind(this));
    });
  }

  handleClick(event) {
    event.preventDefault();

    if (event.target.dataset.selected === "true") {
      return;
    }

    const clickedButton = event.target;
    const groupType = clickedButton.dataset.shade ? "shade" : "undertone";
    const clickedValue = clickedButton.dataset[groupType];

    const availableShades = [];
    const availableUndertones = [];

    // Unselect all buttons in the same group and select the clicked button
    this.buttons.forEach((button) => {
      if (button.dataset[groupType]) {
        button.dataset.selected = button.dataset[groupType] === clickedValue ? "true" : "false";
      }
    });

    // Get currently selected values
    const selectedShade = Array.from(this.buttons)
      .find(btn => btn.dataset.shade && btn.dataset.selected === "true")?.dataset.shade;
    const selectedUndertone = Array.from(this.buttons)
      .find(btn => btn.dataset.undertone && btn.dataset.selected === "true")?.dataset.undertone;

    // Filter variant labels
    this.variantLabels.forEach((label) => {
      const labelShade = label.dataset.shade?.toLowerCase() || "";
      const labelUndertone = label.dataset.undertone?.toLowerCase() || "";

      const matchesShade = !selectedShade || selectedShade === "all" || labelShade.includes(selectedShade);
      const matchesUndertone = !selectedUndertone || selectedUndertone === "all" || labelUndertone.includes(selectedUndertone);

      label.classList.toggle("hidden", !(matchesShade && matchesUndertone));

      if(matchesUndertone) availableShades.push(labelShade);
      if(matchesShade) availableUndertones.push(labelUndertone);
    });

    if(groupType === "shade" && this.undertoneButtons) {
      this.undertoneButtons.forEach((button) => {
        if(availableUndertones.includes(button.dataset.undertone) || button.dataset.undertone === "all") {
          button.disabled = false;
        } else {
          button.disabled = true;
        }
      });
    }

    if(groupType === "undertone" && this.shadeButtons) {
      const shadeContainedInAvailable = (buttonShade) => {
        if (!buttonShade || buttonShade === "all") return true;
        const needle = buttonShade.toLowerCase();
        return availableShades.some((s) =>
          (s || "").split(/\s+/).some((word) => word.toLowerCase().includes(needle))
        );
      };
      this.shadeButtons.forEach((button) => {
        if (shadeContainedInAvailable(button.dataset.shade)) {
          button.disabled = false;
        } else {
          button.disabled = true;
        }
      });
    }
  }
}

customElements.define("shade-filters", ShadeFilters);


class ProductPicker extends HTMLElement {
  constructor() {
    super();

    this.itemCount = parseInt(this.dataset.itemCount);
    this.totalItems = 0;

    this.groups = this.querySelectorAll(".product__picker-group");
    this.button = this.querySelector(".product__picker-button");

    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    this.totalItems = 0;

    this.groups.forEach((group) => {
      const groupDetails = group.querySelector(".product__picker-details");
      const selectedVariant = group.querySelector(".product__picker-variant-input:checked");
      const summaryText = group.querySelector(".product__picker-summary-text");
      const groupTitle = group.querySelector(".product__picker-title-selected");

      if(selectedVariant) {
        const label = selectedVariant.nextElementSibling;
        const variantTitle = selectedVariant.dataset.variantTitle;
        const index = selectedVariant.dataset.index;
        const swatchColor = selectedVariant.dataset.swatchColor;
        const type = selectedVariant.dataset.type;

        summaryText.innerHTML = label.innerHTML;
        groupTitle.innerHTML = variantTitle;

        const bundleItem = this.querySelector(`.product__picker-bundle-item[data-index="${index}"]`);
        const bundleItemSwatch = bundleItem.querySelector(".product__picker-bundle-item-swatch");
        const bundleItemLabel = bundleItem.querySelector(".product__picker-bundle-item-label");

        bundleItemSwatch.style.backgroundColor = swatchColor;
        bundleItemLabel.textContent = `${type}: ${variantTitle}`;

        this.totalItems++;
      }

      groupDetails.open = false;
    });

    if(this.totalItems == this.itemCount) {
      this.button.removeAttribute("disabled");
      this.button.textContent = this.button.dataset.addToCartText;
    }
    else {
      this.button.setAttribute("disabled", true);
      this.button.textContent = this.button.dataset.selectMoreText.replace("|count|", this.itemCount - this.totalItems);
    }
  }
}

customElements.define("product-picker", ProductPicker);


function filterMedia() {
  var checkradio = $(
    'input[type="radio"][data-name="shade-swatches"]:checked',
  ).attr("data-swatch");
  $(".shadlist_dropdown_pdp").val(checkradio);
  if (typeof checkradio === "undefined") {
  } else {
    $('input[type="radio"][data-name="shade-swatches"]').removeClass("active");
    $('input[type="radio"][data-name="shade-swatches"]:checked').addClass(
      "active",
    );
    var title = $(".product__title h1").text();
    // console.log(checkradio);
    $(".thumbnail-list li").each(function () {
      var dataalt = $(this).attr("thumbnail-color");

      var checkcolor = dataalt.includes(checkradio);
      console.log(checkcolor);
      if (dataalt == checkradio) {
        $(this).removeClass("hidden");
      } else if (dataalt == "all") {
        $(this).removeClass("hidden");
      } else {
        if (title != dataalt) {
          $(this).addClass("hidden");
        }
      }
    });

    $("fieldset input").each(function () {
      if ($(this).attr("name") == "BC Foundation") {
        if ($(this).hasClass("active")) {
          var val_1 = $(this).attr("value");
          $(".shade-sel h5 span.shadetxt_bcf").text("BC Foundation");
          $(".shade-sel h5 span.shadedet_bcf").text(val_1);
        }
      }
      if ($(this).attr("name") == "BC Concealer") {
        if ($(this).hasClass("active")) {
          var val_2 = $(this).attr("value");
          $(".shade-sel h5 span.shadetxt_bcc").text("BC Concealer");
          $(".shade-sel h5 span.shadedet_bcf").text(val_2);
        }
      }
      if ($(this).attr("name") == "Super Silk Serum Foundation") {
        if ($(this).hasClass("active")) {
          var val_3 = $(this).attr("value");
          var old_shade = $(this).attr("data-oldshade");
          console.log($(this));
          $(".shade-sel h5 span.shadetxt_bcf").text(
            "Super Silk Serum Foundation",
          );
          $(".shade-sel h5 span.shadedet_bcf").text(val_3 + " " + old_shade);
        }
      }
      if ($(this).attr("name") == "Skin on Skin BC Concealer") {
        if ($(this).hasClass("active")) {
          var val_4 = $(this).attr("value");
          $(".shade-sel h5 span.shadetxt_bcc").text(
            "Skin on Skin BC Concealer",
          );
          $(".shade-sel h5 span.shadedet_bcc").text(val_4);
        }
      }
      if ($(this).attr("name") == "Luxe Lip Oil") {
        if ($(this).hasClass("active")) {
          var val_5 = $(this).attr("value");
          $(".shade-sel h5 span.shadetxt_bcd").text("Luxe Lip Oil");
          $(".shade-sel h5 span.shadedet_bcd").text(val_5);
        }
      }
      if ($(this).attr("name") == "Super Serum Silk Cream Blush") {
        if ($(this).hasClass("active")) {
          var val_6 = $(this).attr("value");
          $(".shade-sel h5 span.shadetxt_bce").text(
            "Super Serum Silk Cream Blush",
          );
          $(".shade-sel h5 span.shadedet_bce").text(val_6);
        }
      }
      if ($(this).attr("name") == "Vibrant Silk Lipstick") {
        if ($(this).hasClass("active")) {
          var val_7 = $(this).attr("value");
          $(".shade-sel h5 span.shadetxt_bca").text("Vibrant Silk Lipstick");
          $(".shade-sel h5 span.shadedet_bca").text(val_7);
        }
      }
    });

    // ingredients

    $(".info_ctm").each(function () {
      var datavarcontent = $(this).attr("data-var-content");

      if (datavarcontent == checkradio) {
        $(this).addClass("clicked");
      } else {
        $(this).removeClass("clicked");
      }
    });
  }
}

$(document).ready(function () {
  filterMedia();
  //$('.product-form__input input[type=radio]').prop('checked', false);

  $(".shadlist_dropdown_pdp").on("change", function () {
    var datadisplay = this.value;
    $('input[type="radio"][data-swatch="' + datadisplay + '"]').trigger(
      "click",
    );
  });
});

// ingredients js

// Hide yotpo for TBYB! Start
document.addEventListener("DOMContentLoaded", function () {
  // Function to handle showing/hiding based on the presence of classes or style
  function updateSubscriptionBoxVisibility() {
    var yotpoWrapper = document.querySelector(
      ".yotpo-plans-and-policy-wrapper",
    );
    var gatedFlowToggle = document.querySelector("gated-flow-toggle");
    var try_now_btn = document.querySelector(".try-now__buttons");

    if (yotpoWrapper) {
      if (
        gatedFlowToggle &&
        getComputedStyle(gatedFlowToggle).display === "none"
      ) {
        // Show the subscription box if gated-flow-toggle is hidden
        yotpoWrapper.style.display = "block";
        if (try_now_btn) try_now_btn.style.display = "block";
        // console.log('Subscription box shown - gated-flow-toggle hidden');
      } else {
        // Otherwise, use the existing logic based on classes
        var toggleChecked = document.querySelector(".tn-gate-toggle-checked");
        var toggleBase = document.querySelector(".tn-gate-toggle-base");

        if (toggleChecked) {
          // Hide the subscription box if .tn-gate-toggle-checked is found
          yotpoWrapper.style.display = "none";
          if (try_now_btn) try_now_btn.style.display = "none";
          // console.log('Subscription box hidden - checked');
        } else if (toggleBase) {
          // Show the subscription box if .tn-gate-toggle-base is found
          yotpoWrapper.style.display = "block";
          if (try_now_btn) try_now_btn.style.display = "block";
          // console.log('Subscription box shown - base');
        } else {
          // Show the subscription box by default if neither class is found
          yotpoWrapper.style.display = "block";
          if (try_now_btn) try_now_btn.style.display = "block";
          // console.log('Subscription box shown - default');
        }
      }
    }
  }

  // Initial update when the page loads
  updateSubscriptionBoxVisibility();

  // MutationObserver to react to changes in the DOM
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes" || mutation.type === "childList") {
        // React to attribute changes or changes in child nodes
        updateSubscriptionBoxVisibility();
      }
    });
  });

  // Start observing changes in the body or a specific container where these classes might change
  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    childList: true,
  });
});
// Hide yotpo for TBYB! End


function handleGiftWithPurchase() {
  if (window.gift.enabled) {
    fetch(`${routes.cart_url}.json?currency=USD`)
      .then((response) => response.json())
      .then((data) => {
        const hasTrigger = data.items.some(
          (item) =>
            item.variant_id === window.gift.trigger_variant_id ||
            (window.gift.trigger_products &&
              window.gift.trigger_products.some(
                (triggerProducts) =>
                  triggerProducts.id == item.product_id
              ))
        );

        const hasGift = data.items.some(
          (item) =>
            item.variant_id === window.gift.variant_id &&
            item.properties['_gift'] === 'true'
        );
        const giftPosition = data.items.findIndex(
          (item) =>
            item.variant_id === window.gift.variant_id &&
            item.properties['_gift'] === 'true'
        );

        const cartTotal = data.total_price;
        const giftBreakpoint = window.gift.breakpoint;

        if (!hasGift) {
          if (window.gift.type == 'price' && cartTotal >= giftBreakpoint) {
            Shopify.addItemsToCart([
              {
                id: window.gift.variant_id,
                quantity: window.gift.quantity,
                properties: {
                  _gift: 'true',
                },
              },
            ]);
          } else if (window.gift.type == 'variant' && hasTrigger) {
            Shopify.addItemsToCart([
              {
                id: window.gift.variant_id,
                quantity: window.gift.quantity,
                properties: {
                  _gift: 'true',
                },
              },
            ]);
          }
        } else if (hasGift) {
          if (window.gift.type == 'price' && cartTotal < giftBreakpoint) {
            Shopify.removeItemFromCart(giftPosition + 1);
          } else if (window.gift.type == 'variant' && !hasTrigger) {
            Shopify.removeItemFromCart(giftPosition + 1);
          }
        }
      });

    return;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.oldItemCount = window.oldItemCount || 0;

  RechargePubSub.subscribe("cart:update", (data) => {
    const itemCount = data.cart.item_count;
    
    if(itemCount != window.oldItemCount) {
      handleGiftWithPurchase();
      window.oldItemCount = itemCount;
    }
  });
});